import { useState, useEffect } from "react";
import Card from "react-bootstrap/Card";
import { Link } from "react-router-dom";
import AppSettings from "../../configs/appSettings";
import "./style.css";
import {Image, ImageType} from "../../models/image";

const ImageCard = ({ image, sku, handleSelectImage }: { image: Image, sku: string, handleSelectImage: any }) => {
  let link =`${image.HighResolution}`;

  return (
    <div className="image-page-cards">
      <div style={{marginBottom:'10px'}}>
        <input id="chkSelect" name="chkSelect" type="checkbox" className="chkSelect" value={image.ImageId ?? ""} checked={image.IsChecked} onChange={(e) => { handleSelectImage(e, image.ImageId, image.FileName);}} /> Select
      </div>
      <Card className="image-cards">
        <a href={link} target="_blank" className="highResolution"> 
          <img className="card-img prd-card-img" title={image.FileName} src={image.Thumbnail == "" ? `data:image/jpg;base64,${image.Blob}` : image.Thumbnail}></img>
        </a>
      </Card>
    </div>
  );
};

export default ImageCard;
